import type { RouteRecordRaw } from 'vue-router';

// TASK-140 (#1152 P0): màn nay SỞ HỮU 5 chuỗi của chính nó (header · nút Add · 3 toast) trong
// `./i18n/`. 58 khoá còn lại của namespace thuộc partial `setup-promotion` — partial đó cũng
// được nhúng dưới /customer-checkout, nên bundle theo route không phủ được nó; nó tự nạp bundle
// riêng qua `usePartialI18n`. `import.meta.glob` phải gọi TRONG file này (Vite resolve theo file
// chứa nó), không viết ở `router/routes.ts`.
const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const promotionManagementRoutes = {
  name: 'promotion-management',
  path: 'promotion-management',
  component: () => import('./PromotionManagement.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
